/* TLC product page intro (Option B: eyebrow and divider).
   Uses what's already on each product: the "Popular" line becomes a small eyebrow above
   the name, price and reviews share one line, and the first sentence of the
   description is picked out. Nothing is removed from the page. */
(function () {
  function commas(s) { return s.replace(/\b(\d{4,})\b/g, function (n) { return Number(n).toLocaleString('en-AU'); }); }

  function run() {
    var form = document.querySelector('.product-form');
    if (!form || form.getAttribute('data-tlcpt')) return;
    form.setAttribute('data-tlcpt', '1');
    form.classList.add('tlcpt');
    var titleRow = form.querySelector('.title-row');
    var h1 = titleRow && titleRow.querySelector('.product-title');

    /* 1. "Popular, loved by 1,600+ mamas" becomes the eyebrow */
    var pop = form.querySelector('.tlc-pdp-popular');
    if (pop && titleRow) {
      var t = pop.textContent.replace(/\s+/g, ' ').trim();
      t = t.replace(/^popular\s*[–—,:\-]*\s*/i, '');
      t = commas(t.charAt(0).toUpperCase() + t.slice(1));
      var eb = document.createElement('p');
      eb.className = 'tlcpt-eb';
      eb.textContent = t;
      titleRow.parentNode.insertBefore(eb, titleRow);
      var popRow = pop.closest('.lightly-spaced-row');
      (popRow || pop).classList.add('tlcpt-hide');
    }

    /* 2. Name only in the title; the colour is still read out and named in the Colour row */
    if (h1 && !h1.querySelector('.tlcpt-col')) {
      var parts = h1.textContent.split('|');
      if (parts.length > 1) {
        var colour = parts.pop();
        h1.textContent = parts.join('|').trim();
        var span = document.createElement('span');
        span.className = 'tlcpt-col visually-hidden';
        span.textContent = ' |' + colour;
        h1.appendChild(span);
      }
    }

    /* 3. Price | reviews on one line, payment line underneath */
    var pc = form.querySelector('.price-container');
    if (pc) {
      pc.classList.add('tlcpt-price');
      [].forEach.call(pc.children, function (c) {
        if (/afterpay/i.test(c.textContent || '') && !c.querySelector('.product-price')) c.classList.add('tlcpt-pay');
      });
      var rev = pc.querySelector('.theme-product-reviews');
      if (rev) {
        rev.classList.add('tlcpt-rev');
        var w = document.createTreeWalker(rev, NodeFilter.SHOW_TEXT);
        var n; while ((n = w.nextNode())) { if (/\d{4,}/.test(n.nodeValue)) n.nodeValue = commas(n.nodeValue); }
      }
    }

    /* 4. Pick out the first sentence of the description */
    var colourRow = form.querySelector('.input-row');
    var rtes = form.querySelectorAll('.lightly-spaced-row .product-info-block .rte');
    for (var i = 0; i < rtes.length; i++) {
      var r = rtes[i];
      if (colourRow && !(r.compareDocumentPosition(colourRow) & Node.DOCUMENT_POSITION_FOLLOWING)) break;
      r.closest('.lightly-spaced-row').classList.add('tlcpt-desc');
      var tw = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), tn = null;
      while ((tn = tw.nextNode())) { if (tn.nodeValue.trim()) break; }
      if (tn && !(tn.parentNode.closest('strong,b'))) {
        var m = tn.nodeValue.match(/^(\s*[^.!?]{3,80}[.!?])(\s+[\s\S]*)?$/);
        if (m) {
          var b = document.createElement('strong');
          b.className = 'tlcpt-lead';
          b.textContent = m[1];
          tn.parentNode.insertBefore(b, tn);
          tn.nodeValue = m[2] || '';
        }
      }
      break;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
